module.exports = __webpack_public_path__ + "assets/img/teacher2.3c0306ab.png";